
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user:{},
    isOverTime: false
  },
  getters: {
    user: state => {
      let _user = localStorage.getItem("USER");
      if (_user) {
        _user = JSON.parse(_user);
      }
      state.user = _user
      return state.user;
    },
    permissions: state => {
      let _permissions = localStorage.getItem("PERMISSIONS");
      if (_permissions) {
        _permissions = JSON.parse(_permissions);
      }
      state.permissions = _permissions
      return state.permissions
    },
  },
  mutations: {
    UPDATEUSER(state, data) {
      state.user = data;
      localStorage.setItem("USER", JSON.stringify(data));
    },
    SETPERMISSIONS(state,data){
      state.permissions = data
      localStorage.setItem("PERMISSIONS", JSON.stringify(data));
    },
    UPDATEOVERTIMESTATUS(state,data) {
      state.isOverTime = data;
    }
  },
});
